import { createSelector } from 'reselect';
import { isLiveChat } from 'util/chat';
import negate from 'lodash/negate';
import { isTicketLiveChat } from '../util/ticketSelector';

const getAssignedTicketsArray = (state) =>
  state.tickets.assignedTickets.allTickets.map((id) => state.tickets.assignedTickets[id]);

export const isAnswered = (ticket) => ticket.unreadCount === 0;

const getUnansweredAssignedTickets = createSelector([getAssignedTicketsArray], (tickets) =>
  tickets.filter(negate(isAnswered))
);

export const getNonLiveChatUnansweredAssignedTickets = createSelector([getUnansweredAssignedTickets], (tickets) =>
  tickets.filter((ticket) => !isLiveChat(ticket.communicationType))
);

export const getLiveChatUnansweredAssignedTickets = createSelector([getUnansweredAssignedTickets], (tickets) =>
  tickets.filter((ticket) => isLiveChat(ticket.communicationType))
);

const getAssignedLiveChatTickets = createSelector([getAssignedTicketsArray], (tickets) =>
  tickets.filter(isTicketLiveChat)
);

const getAssignedNonLiveChatTickets = createSelector([getAssignedTicketsArray], (tickets) =>
  tickets.filter(negate(isTicketLiveChat))
);

const hasUnviewedMessages = (ticket) => ticket.unviewedMessageIds.length > 0;

export const getLiveChatUnviewedAssigned = createSelector([getAssignedLiveChatTickets], (tickets) =>
  tickets.filter(hasUnviewedMessages)
);

export const getNonLiveChatUnviewedAssigned = createSelector([getAssignedNonLiveChatTickets], (tickets) =>
  tickets.filter(hasUnviewedMessages)
);
